import request from "@/api";

export function listNews(data) {
    return request({
        url: '/api/news/getNewsList',
        method: 'get',
        params: data
    })
}
export function saveNews(data) {
    return request({
        url: '/api/news/saveNews',
        method: 'post',
        data: data
    })
}

export function getNewsInfo(data) {
    return request({
        url: '/api/news/getNewsInfo',
        method: 'get',
        params: data
    })
}

export function deleteNews(data) {
    return request({
        url: '/api/news/deleteNews',
        method: 'post',
        data: data
    })
}